"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/onboardingShared/index.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _createNamedExportFrom(obj, localName, importedName) { Object.defineProperty(exports, localName, {enumerable: true, configurable: true, get: () => obj[importedName]}); } function _optionalChain(ops) { let lastAccessLHS = undefined; let value = ops[0]; let i = 1; while (i < ops.length) { const op = ops[i]; const fn = ops[i + 1]; i += 2; if ((op === 'optionalAccess' || op === 'optionalCall') && value == null) { return undefined; } if (op === 'access' || op === 'optionalAccess') { lastAccessLHS = value; value = fn(value); } else if (op === 'call' || op === 'optionalCall') { value = fn((...args) => value.call(lastAccessLHS, ...args)); lastAccessLHS = undefined; } } return value; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _reactrouterdom = require('react-router-dom');
var _hooks = require('web/services/hooks');


var _signup = require('shared/enum/signup');
var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _app = require('shared/selectors/app');
var _user = require('shared/selectors/user');
var _onboardingAnalytics = require('web/services/onboardingAnalytics');
var _SignupStepWrapper = require('web/screens/Signup/components/SignupStepWrapper'); var _SignupStepWrapper2 = _interopRequireDefault(_SignupStepWrapper);
var _types = require('web/screens/Signup/types');
var _downloadModalFlag = require('./downloadModalFlag'); _createNamedExportFrom(_downloadModalFlag, 'markShowDownloadModal', 'markShowDownloadModal'); _createNamedExportFrom(_downloadModalFlag, 'consumeShowDownloadModal', 'consumeShowDownloadModal'); _createNamedExportFrom(_downloadModalFlag, 'arrivedFromOnboarding', 'arrivedFromOnboarding');

/**
 * The authenticated onboarding continuation shell, shared by `OnboardingPayment`
 * and the free-path `OnboardingSteps` so the two screens never drift on the
 * org-param gate, the socket/loader posture, or the finish→inbox terminal.
 *
 * It renders the same high-level signup chrome (title + the persistent
 * Account / Organization / Ready-to-go nav) as the pre-auth setup flow, so the
 * continuation reads as the "Ready to go" stage of one signup — the low-level
 * per-step checklist was deliberately dropped as a second, redundant layer.
 */

 const OnboardingLayout




 = ({ children, size = 'xl' }) => (
  _react2.default.createElement(_SignupStepWrapper2.default, {
    title: "Sign up" ,
    currentStep: _types.SetupSteps.FINISH,
    size: size,
    className: "onboarding-payment--content", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}}

    ,  children 
  )
); exports.OnboardingLayout = OnboardingLayout

/**
 * Reads + validates the `org` query param against the current user's non-pending
 * admin relationships. A foreign/unresolved org is sent to the inbox once the
 * auth bootstrap lands (never stranding the user on a screen they can't act on).
 */
 const useOnboardingOrgGate = () => {
  const { search } = _reactrouterdom.useLocation.call(void 0, )
  const clientOpen = _hooks.useAppSelector.call(void 0, _app.selectIsClientOpen)
  const currentUser = _hooks.useAppSelector.call(void 0, _user.selectCurrentUser)

  const orgParam = _react.useMemo.call(void 0, 
    () => (new URLSearchParams(search).get('org') || '') ,
    [search],
  )
  const isValidOrg =
    !!orgParam && _onboardingAnalytics.getNonPendingAdminOrgKeys.call(void 0, _optionalChain([currentUser, 'optionalAccess', _ => _.Relationships])).includes(orgParam)

  _react.useEffect.call(void 0, () => {
    if (currentUser && !isValidOrg) _actions2.default.gotoInbox()
  }, [currentUser, isValidOrg])

  return { orgParam, clientOpen, currentUser, isValidOrg }
}; exports.useOnboardingOrgGate = useOnboardingOrgGate

// Download-modal flag helpers live in ./downloadModalFlag (a component-free
// module the bootstrap listeners can import); re-exported here so onboarding
// screens keep one import surface.






/**
 * Terminal finish handler for the free-path continuation. Arms the one-shot
 * download modal, then lands in the inbox (the download UI surfaces there as a
 * dismissible modal instead of a terminal screen).
 */
 const useOnboardingFinishToInbox = () =>
  _react.useCallback.call(void 0, () => {
    _downloadModalFlag.markShowDownloadModal.call(void 0, )
    _actions2.default.gotoInbox()
    return Promise.resolve()
  }, []); exports.useOnboardingFinishToInbox = useOnboardingFinishToInbox






















/**
 * Server-authoritative read of the org's onboarding survey. Product interest
 * gates the SMS offer; legacy patient volume still detects the enterprise
 * branch. Fetched once the socket is open and `enabled` (a valid org). A missing
 * survey resolves to empty strings; a FAILED read sets `failed` (with a Sentry
 * event + `onboarding_step_errored`) and exposes `retry` — it is never
 * converted into valid-looking empty answers.
 */
 const useOnboardingSurvey = (
  orgKey,
  enabled,
) => {
  const clientOpen = _hooks.useAppSelector.call(void 0, _app.selectIsClientOpen)
  const [state, setState] = _react.useState.call(void 0, {
    loaded: false,
    failed: false,
    teamSize: '',
    productInterest: '',
    patientsPerMonth: '',
    referrer: '',
  })

  _react.useEffect.call(void 0, () => {
    if (!enabled || !orgKey || !clientOpen || state.loaded || state.failed) return
    let cancelled = false
    _actions2.default.getOrgOnboardingSurvey({ OrgKey: orgKey })
      .then(r => {
        if (cancelled) return
        setState({
          loaded: true,
          failed: false,
          teamSize: _optionalChain([r, 'optionalAccess', _2 => _2.TeamSize]) || '',
          productInterest: _optionalChain([r, 'optionalAccess', _3 => _3.ProductInterest]) || '',
          patientsPerMonth: _optionalChain([r, 'optionalAccess', _4 => _4.PatientsPerMonth]) || '',
          referrer: _optionalChain([r, 'optionalAccess', _5 => _5.Referrer]) || '',
        })
      })
      .catch(err => {
        if (cancelled) return
        log.error(err instanceof Error ? err : String(err))
        _onboardingAnalytics.captureOnboardingStepErrored.call(void 0, { error_kind: 'survey_load', organization_id: orgKey })
        setState(prev => ({ ...prev, failed: true }))
      })
    return () => { cancelled = true }
  }, [enabled, orgKey, clientOpen, state.loaded, state.failed])

  const retry = _react.useCallback.call(void 0, () => setState(prev => ({ ...prev, failed: false })), [])

  return _react.useMemo.call(void 0, () => ({ ...state, retry }), [state, retry])
}; exports.useOnboardingSurvey = useOnboardingSurvey

/** Parses the comma-joined survey `productInterest` string into a set. */
 const parseProductInterest = (raw) =>
  new Set(raw.split(',').map(s => s.trim()).filter(Boolean)); exports.parseProductInterest = parseProductInterest

/** The maximum self-serve SMS volume; above this the org must contact sales. */
 const MAX_SELF_SERVE_PATIENTS_PER_MONTH = 5000; exports.MAX_SELF_SERVE_PATIENTS_PER_MONTH = MAX_SELF_SERVE_PATIENTS_PER_MONTH

/** True once the survey settles and reports patient texting among its intents. */
 const surveyHasSms = (survey) =>
  exports.parseProductInterest.call(void 0, survey.productInterest).has(_signup.ProductInterest.SMS); exports.surveyHasSms = surveyHasSms

/** True when the survey reports team chat among its intents. */
 const surveyHasTeamChat = (survey) =>
  exports.parseProductInterest.call(void 0, survey.productInterest).has(_signup.ProductInterest.TEAM_CHAT); exports.surveyHasTeamChat = surveyHasTeamChat

/** True when the survey reports external collaboration among its intents. */
 const surveyHasExternalChat = (survey) =>
  exports.parseProductInterest.call(void 0, survey.productInterest).has(_signup.ProductInterest.EXTERNAL_CHAT); exports.surveyHasExternalChat = surveyHasExternalChat

/**
 * True when the patients/month answer exceeds the self-serve ceiling — the
 * payment step then shows the enterprise "contact us" surface instead of a
 * checkout (AC6).
 */
 const surveyIsEnterpriseVolume = (survey) => {
  const n = Number(survey.patientsPerMonth)
  return Number.isFinite(n) && n > exports.MAX_SELF_SERVE_PATIENTS_PER_MONTH
}; exports.surveyIsEnterpriseVolume = surveyIsEnterpriseVolume
